module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"edit_button.label":"Editar"},"en":{"edit_button.label":"Edit"}}')
  delete Component.options._Ctor
}
